import React from 'react';

import PropTypes from 'prop-types';

import { NewKeyword } from '@src/components/common/Display/keywords';
/**
 * ### getPlatformFromNewDash
 *
 * Return a platform only
 * the new- text is in area
 * @param {string} type type of option
 * @param {object} option option for menu item
 */
export const getPlatformFromNewDash = ({ title }) => {
    let platform = '';
    if (title.indexOf('New-') > -1) {
        platform = 'agent360';
        title = title.replace('New-', '');
    }

    return (
        <span>
            <NewKeyword platform={platform} />
            {title}
        </span>
    );
};

getPlatformFromNewDash.propTypes = {
    title: PropTypes.string.isRequired,
};
